"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.demoRequest = demoRequest;
exports.isDemoMode = isDemoMode;
var _request = require("./request");
var _coreConfig = _interopRequireDefault(require("../core-config"));
var _coreMerge = _interopRequireDefault(require("../core-merge"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Handles making a demo backend request
 */

/**
 * Determines if the service corresponding to the supplied serviceKey is in
 * demo mode.
 *
 * @param {string} serviceKey The service key to check for demo mode
 * @return {boolean} true if this service is in demo mode, false otherwise
 */
function isDemoMode(serviceKey) {
  var demoFlag = false;
  if (serviceKey) {
    // check demo mode
    if (_coreConfig["default"].get(_coreConfig["default"].external).demoSwitch && _coreConfig["default"].get(_coreConfig["default"].external).demoSwitch[serviceKey] === true) {
      demoFlag = true;
    }
  }
  return demoFlag;
}

/**
* returns a mock response for demo mode
*
* @param {object} options JS object containing all call options, including result callbacks
*/
function demoRequest(options) {
  var serviceKey = options.serviceKey;
  var defaults = {
    timeout: (0, _request.getTimeout)(),
    method: 'GET'
  };
  var opts = _coreMerge["default"].merge({}, defaults, options);

  // override a demo request method to be GET
  opts['method'] = 'GET';
  var url = _coreConfig["default"].get(_coreConfig["default"].internal).cmsUrl + _coreConfig["default"].get(_coreConfig["default"].internal).demoResponsePath + '/' + serviceKey + '.json';
  (0, _request.sendWithAxios)(url, opts);
}
//# sourceMappingURL=demo-request.js.map